import { ENV } from '@/config/env';

export type BookingDeepLinkAction = 'confirm' | 'edit' | 'cancel';

export function buildBookingDeepLink({
  companySlug,
  countryCode,
  confirmationCode,
  action,
}: {
  companySlug: string;
  countryCode: string;
  confirmationCode: string;
  action: BookingDeepLinkAction;
}) {
  const params = new URLSearchParams();

  params.set('action', action);
  params.set('companySlug', companySlug);
  params.set('countryCode', countryCode);

  const qs = params.toString();

  return `${ENV.DEEP_LINKS_URL}/booking/${confirmationCode}${qs ? `?${qs}` : ''}`;
}
